import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface ErrorPageProps {
  code: string;
  title: string;
  hint: string;
}

function ErrorPage({ code, title, hint }: ErrorPageProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Typography variant="h1" sx={{ fontSize: 96, fontWeight: 800, color: 'primary.main' }}>
        {code}
      </Typography>
      <Typography variant="h5" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>
        {hint}
      </Typography>
      <Button component={Link} to="/" variant="contained" size="large">
        {t('errors.goHome')}
      </Button>
    </Box>
  );
}

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <ErrorPage
      code="404"
      title={t('errors.pageNotFound')}
      hint={t('errors.pageNotFoundHint')}
    />
  );
}

export function ForbiddenPage() {
  const { t } = useTranslation();
  return (
    <ErrorPage
      code="403"
      title={t('errors.forbidden')}
      hint={t('errors.forbiddenHint')}
    />
  );
}
